var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#0D99FF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2270_7623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4638 23.8637C25.4755 22.2815 24.85 21.0301 23.6024 20.1463C22.6388 19.4659 21.4695 19.111 20.3385 18.7699C17.9824 18.0557 17.2989 17.6795 17.2989 16.5528C17.2989 15.2977 18.9299 14.8512 20.3262 14.8512C21.343 14.8512 22.5129 15.1673 23.2395 15.6359L24.6798 13.4051C23.7303 12.7895 22.4308 12.3697 21.1475 12.2394V10.1562H18.4904V12.3854C16.1285 12.905 14.6406 14.4487 14.6406 16.5528C14.6406 18.0263 15.2529 19.1949 16.4571 20.0191C17.3729 20.6483 18.4899 20.9862 19.5689 21.3134C21.8799 22.0119 22.8184 22.4375 22.8077 23.8472L22.8076 23.8576C22.8076 25.0407 21.2397 25.4614 19.8964 25.4614C18.6275 25.4614 17.2476 24.9053 16.4655 24.0785L14.5352 25.9044C15.5257 26.952 16.9649 27.6926 18.4903 27.983V30.1563H21.1475V28.0298C23.772 27.6541 25.4612 26.0739 25.4638 23.8637Z",
    fill: "#0D99FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2270_7623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 20,
    fill: "white",
    transform: "translate(14 10.1562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.2a39c8906123c74b58fadf939dc5906c.svg";
export { ForwardRef as ReactComponent };